if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        // Use selectedIndex instead of option[selected] attribute —
        // Safari does not reliably sync the selected attribute when a
        // change event is dispatched programmatically from a custom dropdown
        return Array.from(this.querySelectorAll('select, fieldset input:checked')).map((input) => {
          if (input.tagName === 'SELECT') {
            return input.options[input.selectedIndex]?.dataset.optionValueId;
          }
          return input.dataset.optionValueId;
        }).filter(Boolean);
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          // Use selectedIndex to move the selected attribute — this is always
          // correct in Safari even when change is dispatched programmatically.
          // The original code used selectedOptions[0] which Safari misreports.
          const selectedIndex = target.selectedIndex;
          Array.from(target.options).forEach((option, i) => {
            if (i === selectedIndex) {
              option.setAttribute('selected', 'selected');
            } else {
              option.removeAttribute('selected');
            }
          });

          const swatchValue = target.options[selectedIndex].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.options[selectedIndex].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}